import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=1dd0724c&scoped=true&"
import script from "./purchase-list.vue?vue&type=script&lang=js&"
export * from "./purchase-list.vue?vue&type=script&lang=js&"
import style0 from "./purchase-list.vue?vue&type=style&index=0&id=1dd0724c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd0724c",
  null
  
)

export default component.exports